if (!customElements.get('st-shipping-protection')) {
  let requestPending = false;
  let reconcileTimer;
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const reconcile = async () => {
    if (requestPending) return;
    requestPending = true;
    try {
      const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const lines = cart.items.filter(item => item.handle === 'shipping-protection');
      const hasMerchandise = cart.items.some(item => item.handle !== 'shipping-protection');
      const updates = Object.fromEntries(lines.flatMap((item, index) => {
        const quantity = hasMerchandise && index === 0 ? 1 : 0;
        return item.quantity === quantity ? [] : [[item.key, quantity]];
      }));
      if (!Object.keys(updates).length) return;
      document.querySelectorAll('button[name="checkout"]').forEach(button => { button.disabled = true; });
      const update = await fetch(`${rootUrl()}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      if (update.ok) window.location.assign(`${rootUrl()}cart`);
      else window.location.reload();
    } catch {
      const status = document.querySelector('st-shipping-protection .st-protection__error');
      if (status) {
        status.textContent = status.closest('st-shipping-protection').dataset.error;
        status.hidden = false;
      }
    } finally {
      requestPending = false;
    }
  };
  const scheduleReconcile = () => {
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(reconcile, 100);
  };
  customElements.define('st-shipping-protection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('input');
      input?.addEventListener('change', () => this.update(input));
      scheduleReconcile();
    }

    async update(input) {
      if (this.busy || requestPending) {
        input.checked = !input.checked;
        return;
      }
      this.busy = true;
      requestPending = true;
      const checked = input.checked;
      const root = window.Shopify?.routes?.root || '/';
      const status = this.querySelector('.st-protection__status');
      const error = this.querySelector('.st-protection__error');
      const checkouts = Array.from(document.querySelectorAll('button[name="checkout"]'));
      const previousStates = checkouts.map(button => button.disabled);
      input.disabled = true;
      status.hidden = false;
      error.hidden = true;
      checkouts.forEach(button => { button.disabled = true; });
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        const lines = cart.items.filter(item => String(item.product_id) === this.dataset.productId);
        let response;
        const hasMerchandise = cart.items.some(item => String(item.product_id) !== this.dataset.productId);
        if (checked && hasMerchandise && !lines.length) {
          response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }) });
        } else if (lines.length) {
          const updates = Object.fromEntries(lines.map((item, index) => [item.key, checked && hasMerchandise && index === 0 ? 1 : 0]));
          response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        }
        if (response) {
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        }
        window.location.assign(this.dataset.cartUrl || `${root}cart`);
      } catch (failure) {
        input.checked = !checked;
        input.disabled = false;
        status.hidden = true;
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
        checkouts.forEach((button, index) => { button.disabled = previousStates[index]; });
        this.busy = false;
        requestPending = false;
      }
    }
  });
  const observer = new MutationObserver(records => {
    const changed = records.some(record => Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node instanceof Element && (node.matches('.cart-item') || node.querySelector('.cart-item'))));
    if (changed) scheduleReconcile();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  scheduleReconcile();
}
